module.exports = __webpack_public_path__ + "img/_posmap3.c38ffa23.png";